import { ComponentType } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../context/AuthContext'

interface PrivateRouteProps {
  component: React.ReactNode;
  publicComponent?: React.ReactNode;
}

export const PrivateRoute = ({ component, publicComponent }: PrivateRouteProps) => {
    const { isAuthenticated } = useAuth()
    if (isAuthenticated) {
      return component
    }
  
    if(publicComponent) {
      return publicComponent
    }

    return <Navigate to="/login" replace />
}
